import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Select, { SelectProps } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { setEntityType } from '@apps/shared/src/providerSearch/actions';

import { RootState } from '../../store';
import { IncompleteTheme } from '../../shared/types/theme';

const Header = styled(Typography)(({ theme }) => ({
  ...(theme as IncompleteTheme).sidebar.headerText,
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  ...(theme as IncompleteTheme).selectMenuItem,
  display: 'block',
  padding: '12px 16px',
  minHeight: '48px',
}));

const StyledSelect = styled(Select)({
  width: '100%',
  '& .MuiSelect-select': {
    background: '#ffffff',
    border: '1px solid #E5EBF5',
    padding: '12px 16px',
  },
});

const mapStateToProps = ({ providerSearch }: RootState): StateProps => ({
  entityType: providerSearch.entitytype,
  isLoading: providerSearch.isLoadingProviderList,
});

type StateProps = {
  entityType: string;
  isLoading: boolean;
};

const mapDispatchToProps = {
  setEntityType,
};

type Props = StateProps & typeof mapDispatchToProps;

const getEnityType = (entityType: string) => {
  if (entityType === '1') {
    return 'Professional';
  }
  if (entityType === '2') {
    return 'Facility';
  }
  return 'All';
};

export function EntityTypeFilter({ isLoading, entityType, setEntityType }: Props): JSX.Element {
  const [selectedOption, setSelectedOptions] = useState(
    entityType && entityType.length <= 1 ? getEnityType(entityType) : 'All'
  );
  const entityTypeOptions = ['All', 'Professional', 'Facility'];

  const renderMenuItemValue: SelectProps['renderValue'] = selected => selected as string;

  const handleEntityTypeChange: SelectProps['onChange'] = e => {
    const entityType = e.target.value as string;
    setSelectedOptions(entityType);
    setEntityType(entityType);
  };

  useEffect(() => {
    setSelectedOptions(entityType && entityType.length <= 1 ? getEnityType(entityType) : 'All');
  }, [entityType]);

  return (
    <div>
      <Header>Professional/Facility</Header>
      <StyledSelect
        labelId="EntityType"
        id="entity-type-search"
        value={selectedOption}
        onChange={handleEntityTypeChange}
        disableUnderline
        disabled={isLoading}
        renderValue={renderMenuItemValue}
      >
        {entityTypeOptions.map(option => (
          <StyledMenuItem key={option} value={option}>
            {option}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EntityTypeFilter);
